import { useState, useCallback } from 'react';
import { getDaysInMonth } from '../utils/dateUtils';

export default function useNavigation() {
  const [currentScreen, setCurrentScreen] = useState('home');
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date().getDate());
  const [currentDay, setCurrentDay] = useState(new Date().getDate());
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [lastScreen, setLastScreen] = useState('home');
  const [cameFromNav, setCameFromNav] = useState(false);
  const [viewMonth, setViewMonth] = useState(new Date().getMonth() + 1);
  const [viewYear, setViewYear] = useState(new Date().getFullYear());
  const [searchQuery, setSearchQuery] = useState('');

  const now = new Date();
  const todayDay = now.getDate();
  const todayMonth = now.getMonth() + 1;

  const navigateDay = (direction) => {
    let newDay = currentDay + direction;
    let newMonth = currentMonth;
    let newYear = currentYear;

    if (newDay > getDaysInMonth(currentMonth)) {
      newDay = 1;
      newMonth = currentMonth + 1;
      if (newMonth > 12) {
        newMonth = 1;
        newYear = currentYear + 1;
      }
    } else if (newDay < 1) {
      newMonth = currentMonth - 1;
      if (newMonth < 1) {
        newMonth = 12;
        newYear = currentYear - 1;
      }
      newDay = getDaysInMonth(newMonth);
    }

    setCurrentDay(newDay);
    setCurrentMonth(newMonth);
    setCurrentYear(newYear);
  };

  const goToToday = () => {
    const n = new Date();
    setCurrentDay(n.getDate());
    setCurrentMonth(n.getMonth() + 1);
    setCurrentYear(n.getFullYear());
  };

  const navigateToScreen = useCallback((screen) => {
    if (screen === 'home') {
      const n = new Date();
      setCurrentDay(n.getDate());
      setCurrentMonth(n.getMonth() + 1);
      setCurrentYear(n.getFullYear());
    }
    if (screen === 'month') {
      const n = new Date();
      setViewMonth(n.getMonth() + 1);
      setViewYear(n.getFullYear());
      setSelectedDate(n.getDate());
    }
    setCurrentScreen(screen);
  }, []);

  return {
    currentScreen, setCurrentScreen: navigateToScreen,
    selectedEvent, setSelectedEvent,
    selectedDate, setSelectedDate,
    currentDay, currentMonth, currentYear,
    setCurrentDay, setCurrentMonth, setCurrentYear,
    lastScreen, setLastScreen,
    cameFromNav, setCameFromNav,
    viewMonth, setViewMonth,
    viewYear, setViewYear,
    searchQuery, setSearchQuery,
    todayDay, todayMonth,
    navigateDay, goToToday,
  };
}
